module.exports = __webpack_public_path__ + "img/bol.com.2d95a501.jpg";